import moment from 'moment';

import CommunicationSimulator from './communication_simulator';
import Communicator from 'models/communicator';
import Factory from 'factories/all';

export default class IncomingTaskSimulator extends CommunicationSimulator {
  constructor({ orgId, publisher, services }, database) {
    super({ attribute: 'incomingTasks', createItem: createTaskItem, orgId, publisher, services }, database);
  }

  _createRoutingItem(attrs) {
    return Factory.build('RoutingItemForIncomingTask', this._getRoutingItemAttrs(attrs));
  }
}

function createTaskItem(rawTask) {
  return Factory.build('TaskItem', {
    initiator: {
      type: Communicator.AGENT,
      id: rawTask.agentId,
    },
    content: rawTask.content,
    dueAt: moment().format(),
  });
}



// WEBPACK FOOTER //
// ./src/scripts/infrastructure/backends/communication_simulation_service/incoming_task_simulator.js